module.exports = __webpack_public_path__ + "img/choicemb.6f8471bb.png";